import { useState } from "react";
import { Modal, ModalHeader, Spinner } from "react-bootstrap";
/**
 *
 * @param {{
 * show:boolean,
 * onHide:()=>void,
 * title:string,
 * text:string,
 * onConfirm:()=>void
 * }} props
 */
function Modal3InOne({
  show,
  onHide,
  title,
  text,
  onConfirm, // function async dari parent
}) {
  const [mode, setMode] = useState("confirm"); // confirm | loading | success | error
  const [errorMsg, setErrorMsg] = useState("");

  const handleConfirm = async () => {
    try {
      setMode("loading");

      await onConfirm(); // jalankan proses dari parent

      setMode("success");
    } catch (err) {
      setErrorMsg(err.message || "Terjadi kesalahan");
      setMode("error");
    }
  };

  const resetAndClose = () => {
    setMode("confirm");
    setErrorMsg("");
    onHide();
  };

  const renderContent = () => {
    switch (mode) {
      case "confirm":
        return (
          <>
            <p className="mb-3">{text}</p>
            <button className="btn btn-outline-primary btn-lg w-100" onClick={handleConfirm}>
              Confirm
            </button>
          </>
        );

      case "loading":
        return (
          <div className="text-center py-4">
            <Spinner animation="border" />
            <p className="mt-3">Processing...</p>
          </div>
        );

      case "success":
        return (
          <div className="text-center py-4">
            <h4 className="text-success">Berhasil!</h4>
            <button className="btn btn-success btn-lg w-100 mt-3" onClick={resetAndClose}>
              Joss
            </button>
          </div>
        );

      case "error":
        return (
          <div className="text-center py-4">
            <h4 className="text-danger">Gagal</h4>
            <p>{errorMsg}</p>
            <button className="btn btn-danger btn-lg w-100 mt-3" onClick={resetAndClose}>
              Got it
            </button>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <Modal className="modal modal-cover" backdrop={"static"} keyboard={false} show={show} onHide={resetAndClose} centered>
      <div className="modal-content">
        <ModalHeader closeButton>
          <h5 className="modal-title">{title}</h5>
        </ModalHeader>
        <div className="modal-body">{renderContent()}</div>
      </div>
    </Modal>
  );
}

export default Modal3InOne;
